import { useCallback, useState } from 'react';

export function useToggleFlag(defaultState = false) {
  const [opened, setOpened] = useState(defaultState);
  const close = useCallback(() => setOpened(false), []);
  const open = useCallback(() => setOpened(true), []);

  return [opened, open, close];
}



// WEBPACK FOOTER //
// ./src/hocs/useToogleFlag.js